import { useEffect, useState } from 'react';
import {
  Col,
  Row,
  Typography,
  Button,
  Space,
  Radio,
  Flex,
  Tag,
  Tooltip,
  Avatar,
  Skeleton,
  Result,
  message,
} from 'antd';
import {
  DownloadOutlined,
  ZoomInOutlined,
  PlusOutlined,
  HeartOutlined,
  ShareAltOutlined,
  UserOutlined,
  InfoCircleOutlined,
  CloseOutlined,
  MinusOutlined,
  WarningOutlined,
} from '@ant-design/icons';
import type { RadioChangeEvent } from 'antd';
import GallerysCollection from '../../components/gallery/GallerysCollection';
import { AssetService } from '../../services/assetService';
import { HttpStatus } from '../../constant/responseStatus';
import { AssetPublishModel } from 'src/models/assetModel';
import { useParams, Link, useNavigate } from 'react-router-dom';
import { LicenseService } from '../../services/licenseService';
import { ExtendedLicenseModel, StandardLicenseModel } from '@/src/models/LicenseModel';
import { CollectionService } from '../../services/collectionService';
import { StandardLicense, ExtendedLicense } from '../../constant/licenseConstants';
import { Modal } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import { AssetType, AssetUsage, AssetUsageLabel, DownloadFileName } from '../../constant/assetConstants';
import { useSessionContext } from '../../context/session-context';
import { UserAssetLicenseResponse } from '../../models/responses/userAssetLicenseResponse';
import { UserAssetLicenseService } from '../../services/userAssetLicenseService';
import MyFavoriteModal from 'src/components/modal/myFavoriteModal';
import ShareModal from 'src/components/modal/shareModal';
import { ArtistProfileModel, FollowCreateModel } from 'src/models/accountModel';
import { AccountService } from 'src/services/accountService';
import { CollectionAssetModel } from 'src/models/CollectionModel';
import { FavoriteService } from 'src/services/favoriteService';
import { FavoriteResponseModel } from 'src/models/responses/favoriteModel';
import { BlobFileExtension, PageDocument, StringConstants } from 'src/constant/stringConstants';
import VideoControl from 'src/components/controls/VideoControl';
import { RouteNames } from 'src/routes/routeName';
import ReportAssetModal from 'src/components/modal/reportAssetModal';
import { ExclusiveLicenseModel } from 'src/models/ExclusiveLicenseModel';
import { ReportAssetService } from 'src/services/ReportAssetService';
import GallerysMoreLikeThis from 'src/components/gallery/GallerysMoreLikeThis';
import HelmetComponent from 'src/components/helmet/HelmetComponent';
import TranslationKey from 'src/i18n/translation';
const aiGeneratedIcon = require("../../assets/images/gallery-item/ai_usage_type.png");

const { Title, Text } = Typography;

export default function Product() {
  const navigate = useNavigate();
  const logoLink = `${process.env.REACT_APP_REDIRECT_PATH}/images/logo/logo_alive_square.png`;

  const [stdValue, setStdValue] = useState<StandardLicenseModel>();
  const [extValue, setExtValue] = useState<ExtendedLicenseModel>();
  const [totalPrice, setTotalPrice] = useState(0);
  const [tags, setTags] = useState<string[]>([]);
  const [relateKeywords, setRelateKeywords] = useState<string[]>([]);
  const { getOrderAssets, setOrderAssets: updateOrderAssets, userProfile, getCountOrder } = useSessionContext();
  const [asset, setAsset] = useState<AssetPublishModel>();
  const [orderAsset, setOrderAsset] = useState<AssetPublishModel>({} as AssetPublishModel);
  const [standardLicense, setStandardLicense] = useState<StandardLicenseModel[]>();
  const [extendedLicense, setExtendedLicense] = useState<ExtendedLicenseModel[]>();
  const [, setStandardLicenseVip] = useState<StandardLicenseModel>({} as StandardLicenseModel);
  const [extendedLicenseVip, setExtendedLicenseVip] = useState<ExtendedLicenseModel>({} as ExtendedLicenseModel);
  const [collections, setCollections] = useState<CollectionAssetModel[]>([]);
  const [favorite, setFavorite] = useState<FavoriteResponseModel>({} as FavoriteResponseModel);
  const [isShowContact, setIsShowContact] = useState(false);
  const { id } = useParams();
  const [show, setShowAssetZoom] = useState(false);
  const [cartLoadings, setCartLoadings] = useState<boolean>();
  const [userAssetLicenses, setUserAssetLicenses] = useState<UserAssetLicenseResponse[]>([]);
  const [standardLicenseSelected, setStandardLicenseSelected] = useState('');
  const [canDownloadAssetLicense, setCanDownloadAssetLicense] = useState(false);
  const [downloadLoadings, setDownloadLoadings] = useState<boolean>();
  const [downloadVipLoadings, setDownloadVipLoadings] = useState<boolean>();
  const [isNotFound, setIsNotFound] = useState(false);
  const [isOpenFavorite, setIsOpenFavorite] = useState(false);
  const [isOpenShare, setIsOpenShare] = useState(false);
  const [artist, setArtist] = useState<ArtistProfileModel>({} as ArtistProfileModel);
  const [isFollow, setIsFollow] = useState(false);
  const [isSameAccount, setIsSameAccount] = useState(false);
  const [isVip, setIsVip] = useState(false);
  const [isOpenReport, setIsOpenReport] = useState(false);
  const [isExclusive, setIsExclusive] = useState(false);
  const [isNotReport, setIsNotReport] = useState(false);
  const [messageApi, contextHolder] = message.useMessage();
  const [seeMore, setSeeMore] = useState(false);
  const [thumbnailImageUrl, setThumbnailImageUrl] = useState<string>('');

  useEffect(() => {
    if (asset?.id == id) {
      return;
    }

    onGetAssetPublishAsync();
  }, [id]);

  useEffect(() => {
    if (asset) {
      setRelateKeywords(asset.name.split(' ').map(n => n.trim()));
      onGetLicenseAsync();
      onGetArtistByUserIdAsync(asset.userId);
      onGetCollectionByAssetAsync();
      onGetFavoriteByAssetAsync();
      onGetReportAssetByAssetAsync();
      setTags(asset.keywords);
      setIsVip(userProfile && userProfile.isVip);
      onCheckExclusiveAsync();

      var assetImage = asset?.thumbnailImageUrl ?? `${process.env.REACT_APP_REDIRECT_PATH}/images/logo/logo_alive_square.png`;
      if (assetImage.slice(-1) === '.') {
        assetImage = logoLink;
      }

      setThumbnailImageUrl(assetImage)
    }
  }, [asset]);

  useEffect(() => {
    if (!(stdValue && extValue)) {
      return;
    }

    calculateTotalPrice();
    checkLicense(stdValue.id!, extValue.id!);
  }, [stdValue, extValue]);

  useEffect(() => {
    if (standardLicense) {
      onGetUserAssetLicenseAsync();
    }
  }, [standardLicense]);

  const handleCloseAssetZoom = () => setShowAssetZoom(false);
  const handleCloseFav = () => {
    setIsOpenFavorite(false);
    onGetFavoriteByAssetAsync();
  };
  const handleCloseShare = () => setIsOpenShare(false);
  const handleCloseReport = () => {
    setIsOpenReport(false);
    onGetReportAssetByAssetAsync();
  };
  const handleShowAssetZoom = () => setShowAssetZoom(true);

  const onChangeStdLicense = ({ target: { value } }: RadioChangeEvent) => {
    const stdLicense = standardLicense?.filter(e => e.id === value)[0];
    if (stdLicense) {
      setStdValue(stdLicense);
    }
  };

  const onChangeExtLicense = ({ target: { value } }: RadioChangeEvent) => {
    const extLicense = extendedLicense?.filter(e => e.id === value)[0];
    if (extLicense) {
      setExtValue(extLicense);
    }
  };

  const canDownloadComp = () => {
    const hasLicense = userAssetLicenses.some(ual => !ual.extendedLicenses.some(e => e.code === ExtendedLicense.VIP));
    return isVip && !isExclusive && !asset?.isDisabled && !hasLicense && userProfile.isCanDownloadComp;
  };

  const onGetAssetPublishAsync = async () => {
    const {
      data: responseData,
      status: responseStatus
    } = await new AssetService().getAssetPublishAsync(id!);

    if (responseStatus !== HttpStatus.OK) {
      setIsNotFound(true);
      return;
    }

    window.scrollTo({ top: 0, behavior: 'smooth' });

    setAsset(responseData);
    onGetUserAssetLicenseAsync();
    prepairAssetToOrder(responseData);
  };

  const onGetUserAssetLicenseAsync = async () => {
    const {
      data: responseData,
      status: responseStatus
    } = await new UserAssetLicenseService().getByAssetIdAsync(id!);

    if (responseStatus !== HttpStatus.OK || responseData.length === 0) {
      return;
    }

    setUserAssetLicenses(responseData);
    setDefaultLicenseSelected(responseData);
  };

  const setDefaultLicenseSelected = (userAssetLicense: UserAssetLicenseResponse[]) => {
    const largeLicenses =
      userAssetLicense.filter(ual =>
        ual.standardLicense.code === StandardLicense.XL ||
        ual.standardLicense.code === StandardLicense.UHD);

    const smallLicenses =
      userAssetLicense.filter(ual =>
        ual.standardLicense.code === StandardLicense.SM ||
        ual.standardLicense.code === StandardLicense.HD);

    if (largeLicenses.length > 0) {
      const maxExt = getMaxExtendedLicense(largeLicenses);
      setStdValue(maxExt!.standardLicense);
      setExtValue(maxExt!.extendedLicenses[0]);
      setStandardLicenseSelected(maxExt!.standardLicenseId);

      return;
    }

    if (smallLicenses.length > 0) {
      const maxExt = getMaxExtendedLicense(smallLicenses);
      setStdValue(maxExt!.standardLicense);
      setExtValue(maxExt!.extendedLicenses[0]);
      setStandardLicenseSelected(maxExt!.standardLicenseId);

      return;
    }
  }

  const getMaxExtendedLicense = (userAssetLicenseResponses: UserAssetLicenseResponse[]) => {
    if (userAssetLicenseResponses.length === 0) {
      return null;
    }

    let maxValue = userAssetLicenseResponses[0];

    for (const license of userAssetLicenseResponses) {
      if (license.extendedLicenses[0].sequence > maxValue.extendedLicenses[0].sequence) {
        maxValue = license;
      }
    }

    return maxValue;
  }

  const prepairAssetToOrder = (data: AssetPublishModel) => {
    let orderAsset: AssetPublishModel;
    orderAsset = {
      id: data.id,
      assetType: data.assetType,
      code: data.code,
      name: data.name,
      description: data.description,
      thumbnailImageUrl: data.thumbnailImageUrl,
      thumbnailVideoUrl: data.thumbnailVideoUrl,
      thumbnailVideoCoverUrl: data.thumbnailVideoCoverUrl,
      hasSMLicense: data.hasSMLicense,
      hasXLLicense: data.hasXLLicense,
      hasHDLicense: data.hasHDLicense,
      hasUHDLicense: data.hasUHDLicense,
      publishDate: data.publishDate,
      hasCollection: data.hasCollection,
      keywords: data.keywords,
      userId: data.userId,
      standardLicense: data.standardLicense,
      extendedLicense: data.extendedLicense,
      price: data.price,
      isDisabled: data.isDisabled,
      isHasLicense: canDownloadAssetLicense,
      imageOrientation: data.imageOrientation,
      usage: data.usage,
      width: data.width,
      height: data.height,
    };
    setOrderAsset(orderAsset);
  };

  const onGetArtistByUserIdAsync = async (userId: string) => {
    const { data: responseData, status: responseStatus } = await new AccountService().getArtistById(userId);
    if (responseStatus !== HttpStatus.OK) {
      return;
    }
    setArtist(responseData);
    if (responseData) {
      onCheckFollowArtistAsync();
      if (userProfile && userProfile.userId) {
        setIsSameAccount(userProfile.userId === responseData.artist.id);
      }
    }
  };

  const onFollowArtistAsync = async (id: string) => {
    const followCreate = { artistId: id } as FollowCreateModel;
    const { status: responseStatus } = await new AccountService().followByArtistId(followCreate);
    if (responseStatus !== HttpStatus.CREATED) {
      messageApi.open({
        type: 'error',
        content: TranslationKey('loginToUseThisFeature'),
      });
      return;
    }
    messageApi.open({
      type: 'success',
      content: TranslationKey('follows.followSuccess'),
    });
    onCheckFollowArtistAsync();
  };

  const onUnfollowArtistAsync = async (id: string) => {
    const { status: responseStatus } = await new AccountService().unfollowByArtistId(id);
    if (responseStatus !== HttpStatus.NO_CONTENT) {
      messageApi.open({
        type: 'error',
        content: TranslationKey('follows.unFollowSuccess'),
      });
      return;
    }
    messageApi.open({
      type: 'success',
      content: TranslationKey('follows.unFollowSuccess'),
    });
    onCheckFollowArtistAsync();
  };

  const onCheckFollowArtistAsync = async () => {
    const { data: responseData, status: responseStatus } = await new AccountService().getFollower(asset?.userId!);
    if (responseStatus !== HttpStatus.OK) {
      setIsFollow(false);
      return;
    }
    setIsFollow(responseData.artistId === asset?.userId!);
  };

  const checkLicense = (stdId: string, extId: string) => {
    setCanDownloadAssetLicense(false);
    setStandardLicenseSelected('');

    if (userAssetLicenses.length === 0) {
      return;
    }

    const userStdLicenses =
      userAssetLicenses.filter((ual) =>
        ual.standardLicenseId === stdId &&
        ual.extendedLicenses.some((el) => el.id === extId));

    if (userStdLicenses.length === 0) {
      return;
    }


    setCanDownloadAssetLicense(true);

    setStandardLicenseSelected(userStdLicenses[0].id);
    setOrderAsset((pre) => ({
      ...pre,
      isHasLicense: userAssetLicenses.filter((x) => x.standardLicenseId === stdId).length > 0,
    }));

    calculateTotalPrice();
  };

  const calculateTotalPrice = () => {
    if (!stdValue || !extValue) {
      return;
    }

    setIsShowContact(extValue.code === ExtendedLicense.EX3PLUS);

    setOrderAsset((pre) => ({ ...pre, standardLicense: stdValue }));
    setOrderAsset((pre) => ({ ...pre, extendedLicense: extValue }));

    const userHasStandardLicense =
      userAssetLicenses.filter((ual) => ual.standardLicenseId === stdValue.id).length > 0;

    const totalPrice =
      userHasStandardLicense
        ? extValue.price
        : stdValue.price + extValue.price;

    setTotalPrice(totalPrice);

    setOrderAsset((pre) => ({
      ...pre,
      price: totalPrice,
      isHasLicense: userHasStandardLicense,
    }));
  };

  const onGetStandardLicenseAsync = async () => {
    if (!asset) {
      return;
    }

    const {
      data: standardLicenseData,
      status: standardLicenseStatus
    } = await new LicenseService().GetStandardLicenseByType(asset.assetType);

    if (standardLicenseStatus !== HttpStatus.OK) {
      return;
    }

    setStandardLicense(standardLicenseData);

    switch (asset.assetType) {
      case AssetType.IMAGE: {
        setStandardLicenseVip(standardLicenseData.filter((x) => x.code === StandardLicense.SM)[0]);

        if (!asset.hasSMLicense) {
          setStandardLicense(standardLicenseData.filter((x) => x.code !== StandardLicense.SM));
        }

        if (!asset.hasXLLicense) {
          setStandardLicense(standardLicenseData.filter((x) => x.code !== StandardLicense.XL));
        }

        break;
      }
      case AssetType.VIDEO: {
        setStandardLicenseVip(standardLicenseData.filter((x) => x.code === StandardLicense.HD)[0]);

        if (!asset?.hasHDLicense) {
          setStandardLicense(standardLicenseData.filter((x) => x.code !== StandardLicense.HD));
        }

        if (!asset?.hasUHDLicense) {
          setStandardLicense(standardLicenseData.filter((x) => x.code !== StandardLicense.UHD));
        }

        break;
      }
    }

    return standardLicenseData;
  }

  const onGetExtendedLicenseAsync = async () => {
    const {
      data: extendLicenseData,
      status: extendLicenseStatus
    } = await new LicenseService().GetExtendedLicenseByType(
      asset?.assetType!
    );

    if (extendLicenseStatus !== HttpStatus.OK) {
      return;
    }

    const extendedLicenseWithoutVip = extendLicenseData.filter((x) => x.code !== ExtendedLicense.VIP);

    setExtendedLicense(extendedLicenseWithoutVip);
    setExtendedLicenseVip(extendLicenseData.filter((x) => x.code === ExtendedLicense.VIP)[0]);

    return extendedLicenseWithoutVip;
  }

  const onGetLicenseAsync = async () => {
    const [stdLicenses, extLicenses] =
      await Promise.all([
        onGetStandardLicenseAsync(),
        onGetExtendedLicenseAsync()
      ]);

    const defaultStdLicense = stdLicenses?.filter((sl) => sl.assetType === asset?.assetType)[0];
    const defaultExtLicense = extLicenses?.filter((el) => el.assetType === asset?.assetType)[0];

    if (!defaultStdLicense || !defaultExtLicense) {
      return;
    }

    setStdValue(defaultStdLicense);
    setExtValue(defaultExtLicense);

    checkLicense(
      defaultStdLicense.id,
      defaultExtLicense.id,
    );
  };

  const onGetCollectionByAssetAsync = async () => {
    const { data: responseData, status: responseStatus } = await new CollectionService().GetCollectionByAssetPath(id!);
    if (responseStatus !== HttpStatus.OK) {
      return;
    }
    setCollections(responseData);
  };

  const onGetFavoriteByAssetAsync = async () => {
    const { data: responseData, status: responseStatus } = await new FavoriteService().getFavoriteByAssetIdAsync(id!);
    if (responseStatus !== HttpStatus.OK) {
      setFavorite({} as FavoriteResponseModel);
      return;
    }
    setFavorite(responseData);
  };

  const onGetReportAssetByAssetAsync = async () => {
    const { status: responseStatus } = await new ReportAssetService().getReportAssetByAssetIdAsync(
      id!
    );
    if (responseStatus !== HttpStatus.OK) {
      setIsNotReport(false);
      return;
    }
    setIsNotReport(true);
  };

  const onCheckExclusiveAsync = async () => {
    const { data: responseData, status: responseStatus } =
      await new UserAssetLicenseService().getCalculateExclusiveAsync(id!);
    if (responseStatus !== HttpStatus.OK) {
      setIsExclusive(false);
      return;
    }
    const exclusiveData = responseData as ExclusiveLicenseModel;
    if (exclusiveData && exclusiveData.applicationUser) {
      const exclusiveDate = new Date(exclusiveData.extendedLicenseExpireDate);
      const nowDate = new Date();
      if (exclusiveData.exclusive > 0 && nowDate <= exclusiveDate) {
        setIsExclusive(true);
        if (userProfile && userProfile.userId === exclusiveData.applicationUser.id) {
          setIsExclusive(false);
        }
      }
    }
  };

  const onAddCart = () => {
    enterLoading();
    let orders = getOrderAssets();
    if (!orders) {
      orders = [];
    }
    const dubIndex = orders.findIndex((order) => order.id === orderAsset.id);
    const isExtendedLicense = orderAsset.extendedLicense.code !== ExtendedLicense.NONE;
    const nolicenseIndex = orders.findIndex(
      (order) =>
        order.id === orderAsset.id &&
        order.standardLicense.id === orderAsset.standardLicense.id &&
        order.extendedLicense.code === ExtendedLicense.NONE
    );
    const hasExtlicense =
      orders.filter(
        (order) =>
          order.id === orderAsset.id &&
          order.standardLicense.id === orderAsset.standardLicense.id &&
          order.extendedLicense.code !== ExtendedLicense.NONE
      ).length > 0;
    if (isExtendedLicense && nolicenseIndex > -1) {
      orders.splice(nolicenseIndex, 1);
    }
    if ((!isExtendedLicense && hasExtlicense) || dubIndex > -1) {
      orders.splice(dubIndex, 1);
    }
    orders.push(orderAsset);
    updateOrderAssets(orders);
    messageApi.open({
      type: 'success',
      content: TranslationKey('cart.addItemToCartSuccess')
    });
    getCountOrder();
  };

  const onDownload = async () => {
    if (standardLicenseSelected === '') {
      return;
    }

    setDownloadLoadings(true);

    const {
      data: responseData,
      status: responseStatus
    } = await new UserAssetLicenseService().donwloadByIdAsync(
      standardLicenseSelected!
    );

    if (responseStatus !== HttpStatus.OK) {
      setDownloadLoadings(false);
      return;
    }

    const downloadLink = document.createElement('a');
    downloadLink.href = URL.createObjectURL(responseData);
    downloadLink.download = asset?.assetType === AssetType.IMAGE
      ? `${asset!.code}${DownloadFileName.Suffix}${BlobFileExtension.Image}`
      : `${asset!.code}${DownloadFileName.Suffix}${BlobFileExtension.Video}`;

    document.body.appendChild(downloadLink);
    downloadLink.click();
    document.body.removeChild(downloadLink);
    setDownloadLoadings(false);
  };

  const onDownloadVip = async () => {
    setDownloadVipLoadings(true);
    const { data: responseData, status: responseStatus } = await new UserAssetLicenseService().downloadVipByIdAsync(
      asset?.id!,
      stdValue!.id,
      extendedLicenseVip.id
    );
    if (responseStatus !== HttpStatus.OK) {
      setDownloadVipLoadings(false);
      messageApi.open({
        type: 'error',
        content: 'download not found.',
      });
      return;
    }
    const downloadLink = document.createElement('a');
    downloadLink.href = URL.createObjectURL(responseData);
    downloadLink.download = asset?.assetType === AssetType.IMAGE
      ? `${asset!.code}${DownloadFileName.Suffix}${BlobFileExtension.Image}`
      : `${asset!.code}${DownloadFileName.Suffix}${BlobFileExtension.Video}`;
    document.body.appendChild(downloadLink);
    downloadLink.click();
    document.body.removeChild(downloadLink);
    setDownloadVipLoadings(false);
    messageApi.open({
      type: 'success',
      content: 'download success.',
    });
  };

  const enterLoading = () => {
    setCartLoadings(true);
    setTimeout(() => {
      setCartLoadings(false);
    }, 2000);
  };

  const onClickFavorite = () => {
    if (userProfile && userProfile.userId) {
      setIsOpenFavorite(true);
    } else {
      messageApi.open({
        type: 'error',
        content: TranslationKey('loginToUseThisFeature'),
      });
    }
  };

  const onClickToArtist = () => {
    navigate(`/artist/${artist.userId}`)
  };

  const onClickShare = () => {
    setIsOpenShare(true);
  };

  const onClickReport = () => {
    setIsOpenReport(true);
  };

  const onTryDownload = async () => {
    const {
      data: responseData,
      status: responseStatus
    } = await new UserAssetLicenseService().tryDownloadAsync(asset?.id!);
    if (responseStatus !== HttpStatus.OK) {
      messageApi.open({
        type: 'error',
        content: 'download not found.',
      });
      return;
    }
    const downloadLink = document.createElement('a');
    downloadLink.href = URL.createObjectURL(responseData);
    downloadLink.download =
      asset?.assetType === AssetType.IMAGE
        ? `${asset!.code}${DownloadFileName.Suffix}${BlobFileExtension.Image}`
        : `${asset!.code}${DownloadFileName.Suffix}${BlobFileExtension.Video}`;
    document.body.appendChild(downloadLink);
    downloadLink.click();
    document.body.removeChild(downloadLink);
  };

  if (isNotFound || isExclusive) {
    return (
      <Row
        className='pt-5'
        justify='center'
      >
        <Col span={24}>
          <Result
            status='404'
            title='404'
            subTitle='Sorry, the page you visited does not exist.'
            className='result-error'
            extra={[
              <a
                href='/'
                className='btn-orange-round'
                style={{ textDecoration: 'none' }}
              >
                Go to home
              </a>,
            ]}
          />
        </Col>
      </Row>
    );
  }

  const seeMoreKeywords = () => {
    setSeeMore(!seeMore);
  };

  const ArtistAvatar = () => (
    artist.avatarUrl
      ?
      <Link to={`/artist/${artist.userId}`} className='text-light'>
        <Avatar
          size='large'
          src={<img src={artist.avatarUrl} alt={artist.artist.nameInfoEn?.firstname + ' ' + artist.artist.nameInfoEn?.lastname} />}
        />
      </Link>
      :
      <Link to={`/artist/${artist.userId}`} className='text-light'>
        <Avatar
          size='large'
          icon={<UserOutlined />}
          alt='artist'
          style={{ backgroundColor: 'rgb(255, 85, 1)' }}
        />
      </Link>
  );

  const ArtistProfile = () => {
    if (!(artist.artist)) {
      return <>
        <Row align='middle' className='mt-3'>
          <Skeleton active />
        </Row>
      </>
    }

    const canReport = userProfile && userProfile.userId && !isNotReport;

    return <>
      <Row align='middle' className='mt-3'>
        <div className='info-profile'>
          <div className='info-name d-flex align-items-center'>
            <ArtistAvatar />
            <Title level={4} className='text-light my-0 me-3 ms-3'>
              <Link to={`/artist/${artist.userId}`} className='text-light'>
                {artist.artist.nameInfoEn && artist.artist.nameInfoEn?.firstname + ' ' + artist.artist.nameInfoEn?.lastname}
              </Link>
            </Title>
          </div>
          <div className='info-social'>
            {
              isFollow
                ?
                <Button
                  type='primary'
                  shape='round'
                  onClick={() => onUnfollowArtistAsync(artist.artist.id)}
                  className={`btn-outline-border active`}
                  hidden={isSameAccount}
                  size='large'
                >
                  {TranslationKey('unFollow')}
                </Button>
                :
                <Button
                  type='primary'
                  shape='round'
                  onClick={() => onFollowArtistAsync(artist.artist.id)}
                  className={`btn-outline-border`}
                  hidden={isSameAccount}
                  size='large'
                >
                  {TranslationKey('follow')}
                </Button>
            }
            <Space wrap className='ms-2'>
              {
                favorite.id
                  ?
                  <Button
                    block
                    type='primary'
                    shape='circle'
                    size='large'
                    icon={<HeartOutlined />}
                    className='btn-primary icon-fix'
                    onClick={onClickFavorite}
                  />

                  :
                  <Button
                    type='primary'
                    shape='circle'
                    size='large'
                    icon={<HeartOutlined />}
                    className='btn-outline icon-fix'
                    onClick={onClickFavorite}
                  />
              }
              <Button
                type='primary'
                shape='circle'
                size='large'
                icon={<DownloadOutlined />}
                className='btn-outline icon-fix'
                onClick={onTryDownload}
              />
              <Button
                type='primary'
                shape='circle'
                size='large'
                icon={<ShareAltOutlined />}
                className='btn-outline icon-fix'
                onClick={onClickShare}
              />
              {
                canReport &&
                <Button
                  type='primary'
                  shape='circle'
                  size='large'
                  icon={<InfoCircleOutlined />}
                  className='btn-outline icon-fix'
                  onClick={onClickReport}
                />
              }
            </Space>
          </div>
        </div>
      </Row>
    </>
  }

  const Keywords = () => (
    <Flex className='mt-4' wrap="wrap" gap="small">
      <p className='fw-bold text-primary mb-0 me-3'>{TranslationKey('keywords')} </p>
      {seeMore
        ? tags.sort((a, b) => (a < b ? -1 : 1)).map((tag, index) => (
          <Tag
            key={index}
            className='tag-outline pointer'
            onClick={() => navigate(`${RouteNames.search}?q=${tag}`)}
          >
            {tag}
          </Tag>
        ))
        : tags.sort((a, b) => (a < b ? -1 : 1)).map((tag, index) => (
          <div key={index}>
            {
              index < 3
                ?
                <Tag
                  key={index}
                  className='tag-outline pointer'
                  onClick={() => navigate(`${RouteNames.search}?q=${tag}`)}
                >
                  {tag}
                </Tag>
                : StringConstants.EMPTY
            }
          </div>
        ))
      }
      <Button
        type="text"
        className='text-white'
        icon={!seeMore ? <PlusOutlined /> : <MinusOutlined />}
        size='small'
        onClick={seeMoreKeywords}>
        {!seeMore ? TranslationKey('assetDetail.showMore') : TranslationKey('assetDetail.showLess')}
      </Button>
    </Flex>
  );

  const LicenseSelector = () => (
    <>
      <Title level={5} className='text-light mt-4 mb-0'>
        {TranslationKey('assetDetail.selectLicense')}
        <Tooltip title={
          <div>
            <div>
              {TranslationKey('assetLicenseInfo.standard.1')}
            </div>
            <br />
            <div>
              {TranslationKey('assetLicenseInfo.standard.2')}
            </div>
          </div>
        }>
          <InfoCircleOutlined style={{ paddingLeft: '0.5rem' }} />
        </Tooltip>
      </Title>
      <Radio.Group
        onChange={onChangeStdLicense}
        value={stdValue?.id}
        optionType='button'
        className='mt-3'
        size='large'
      >
        {standardLicense?.map((s, index) => (
          <Radio value={s.id} key={index}>
            <p className='fs-md'>{s.name}</p>
            <p className='fs-sm'>
              {StringConstants.BAHT + ' ' + s.price.toLocaleString(undefined, { maximumFractionDigits: 2 })}
            </p>
          </Radio>
        ))}
      </Radio.Group>
      <Title level={5} className='text-light mt-4 mb-0'>
        {TranslationKey('assetDetail.selectExtendedLicense')}
        <Tooltip title={
          <div>
            <div style={{ fontWeight: 'bold' }}>
              {TranslationKey('assetLicenseInfo.extended.1')}
            </div>
            <br />
            <div>
              {TranslationKey('assetLicenseInfo.extended.2')}
            </div>
            <br /><br />
            <div style={{ fontWeight: 'bold' }}>
              {TranslationKey('assetLicenseInfo.extended.3')}
            </div>
            <br />
            <div>
              {TranslationKey('assetLicenseInfo.extended.4')}
            </div>
          </div>
        }>
          <InfoCircleOutlined style={{ paddingLeft: '0.5rem' }} />
        </Tooltip>
      </Title>
      <div className='bg-outline-gray boxradius mt-2'>
        <Radio.Group
          onChange={onChangeExtLicense}
          value={extValue?.id}
          className='custom-color-radio'
          size='large'
        >
          <Space direction='vertical' size={'middle'}>
            {extendedLicense
              ?.filter((x) => x.assetType === asset?.assetType)
              .map((e, index) => (
                <Radio value={e.id} className='text-gray' key={index}>
                  +
                  <span className='text-light mx-1 fw-bold'>
                    {e.price > 0
                      ? StringConstants.BAHT + ' ' + e.price.toLocaleString(undefined, { maximumFractionDigits: 2 })
                      : ''}
                  </span>
                  {e.price > 0 && e.name !== 'Merchandise Product for Resale'
                    ? <Tooltip title="This guarantees exclusivity for a specified length of time from the date of the Arts and Contents purchase and includes free unlimited copies, viewers, and worldwide, in perpetuity. An Exclusive Market Freeze license is not refundable and is only offered as an add-on to the X-Large Standard License.">{e.name}</Tooltip>
                    : <>{e.name}</>}
                </Radio>
              ))}
          </Space>
        </Radio.Group>
      </div>
    </>
  );

  const ActionButtons = () => (
    <Row gutter={[8, 8]} className='mt-3'>
      {
        isShowContact
          ?
          <Col span={canDownloadComp() ? 18 : 24}>
            {
              asset &&
              <Link
                to={RouteNames.contactus}
                state={{
                  message: `Market Freeze 3 Year+ , asset code:${asset.code}, link:${window.location.href}`,
                }}
              >
                <Button
                  type='primary'
                  shape='round'
                  className='btn-primary'
                  size='large'
                  block
                >
                  {TranslationKey('assetDetail.contactUs')}
                </Button>
              </Link>
            }

          </Col>
          :
          <>
            {
              asset && !asset.isDisabled &&
              !canDownloadAssetLicense &&
              !isExclusive && (
                <>
                  {/* <p>
                    hasUserLicense is
                    {canDownloadAssetLicense ? ' true' : ' false'}
                  </p> */}
                  <Col span={canDownloadComp() ? 9 : 12}>
                    <Button
                      type='primary'
                      shape='round'
                      className='btn-outline-border'
                      size='large'
                      onClick={onAddCart}
                      block
                      loading={cartLoadings}
                      hidden={isSameAccount}
                    >
                      {TranslationKey('cart.addToCart')}
                    </Button>
                  </Col>
                  <Col span={canDownloadComp() ? 9 : 12}>
                    <Link
                      to={{ pathname: '/order' }}
                      state={{
                        assetId: orderAsset?.id,
                        standardLicenseId: orderAsset?.standardLicense?.id,
                        extendedLicenseId: orderAsset?.extendedLicense?.id,
                      }}
                    >
                      <Button
                        type='primary'
                        shape='round'
                        className='btn-primary'
                        size='large'
                        block
                        hidden={isSameAccount}
                      >
                        {TranslationKey('assetDetail.buyNow')}
                      </Button>
                    </Link>
                  </Col>
                </>
              )
            }
          </>
      }
      {
        canDownloadComp() &&
        <Col span={6}>
          <Button
            type='primary'
            shape='round'
            className='btn-light'
            size='large'
            onClick={onDownloadVip}
            loading={downloadVipLoadings}
            block
          >
            COMP
            <DownloadOutlined className='icon-fix' />
          </Button>
        </Col>
      }
    </Row>
  );

  const AssetZoomModal = () => (
    <Modal
      show={show}
      onHide={handleCloseAssetZoom}
      dialogClassName='img-modal'
      centered
    >
      <Modal.Body>
        <CloseOutlined
          className='button-close'
          onClick={() => setShowAssetZoom(!show)}
          style={{ fontSize: '2em' }}
        />
        {
          asset?.assetType === AssetType.IMAGE
            ?
            <img src={asset?.thumbnailImageUrl} alt={asset?.description} />
            :
            <video
              muted
              loop
              className='product-vdo'
              controls
            >
              <source
                src={asset?.thumbnailVideoUrl}
                type='video/mp4'
              />
              <source
                src={asset?.thumbnailVideoUrl}
                type='video/webm'
              />
              Your browser is not supported!
            </video>
        }
      </Modal.Body>
    </Modal>
  );

  const AssetViewBox = () => (
    <div className='img-info banner-margin-t-70' style={{ textAlign: 'center' }}>
      {
        asset
          ? (
            asset?.assetType === AssetType.IMAGE
              ?
              (
                <div style={{ position: 'relative', display: 'inline-block' }}>
                  <img
                    onClick={handleShowAssetZoom}
                    src={asset?.thumbnailImageUrl}
                    className='product-img'
                    alt={asset.name}
                    style={{ display: 'block' }}
                  />
                  {buildAiLogo()}
                </div>
              )
              :
              (
                <div style={{ position: 'relative', display: 'inline-block' }}>
                  <VideoControl
                    src={asset?.thumbnailVideoUrl}
                    muted={true}
                    loop={true}
                    className='product-vdo'
                    controls={true}
                  />
                  {buildAiLogo()}
                </div>
              )
          )
          : <Skeleton.Image active />}
      <Space className='but-img-zoom'>
        <ZoomInOutlined onClick={handleShowAssetZoom} />
        <Tooltip
          title={
            <span onClick={onClickToArtist}>
              {
                artist.artist &&
                artist.artist.nameInfoEn.firstname + " " + artist.artist.nameInfoEn.lastname
              }
            </span>
          }>
        </Tooltip>
      </Space>
    </div>
  );

  const buildAiLogo = () => {
    if (asset?.usage !== AssetUsage.AiGenerated) {
      return null;
    }

    return (
      <img src={aiGeneratedIcon}
        style={{
          width: 20,
          color: 'white',
          position: 'absolute',
          top: 10,
          left: 10,
        }} />
    );
  };

  const AssetUsageTag = () => (
    <Row className='mt-3'>
      <Col>
        <span className='fw-bold text-primary me-2'>{TranslationKey('usage')} </span>
        <Tag className='tag-outline'>
          {(() => {
            switch (asset?.usage) {
              case AssetUsage.AiGenerated:
                return AssetUsageLabel.AiGenerated;
              case AssetUsage.Commercial:
                return AssetUsageLabel.Commercial;
              case AssetUsage.Editorial:
                return AssetUsageLabel.Editorial;
              default:
                return '-';
            }
          })()}
        </Tag>
      </Col>
    </Row>
  );

  const AssetUsageDescription = () => (
    <>
      {
        asset?.usage === AssetUsage.Editorial &&
        <div className='box-warning'>
          <span>
            <WarningOutlined className='box-warning-icon'/>
            {TranslationKey('assetDetail.usageInfo.editorial.1') + ' '}
            {TranslationKey('assetDetail.usageInfo.editorial.2')}
          </span>
        </div>
      }
      {
        asset?.usage === AssetUsage.AiGenerated &&
        <div className='box-warning'>
          <span>
            <WarningOutlined className='box-warning-icon'/>
            {TranslationKey('assetDetail.usageInfo.aiGenerated.1') + ' '}
            {TranslationKey('assetDetail.usageInfo.aiGenerated.2') + ' '}
            {TranslationKey('assetDetail.usageInfo.aiGenerated.3')}
          </span>
        </div>
      }
    </>
  );

  const AssetTitleDescription = () => (
    <>
      <Title level={5} className='text-gray mt-4'>
        {asset!.code}
        {asset!.name && <> - {asset!.name}</>}
      </Title>
      <Title level={5} className='text-light mt-4 mb-0'>
        {TranslationKey('assetDetail.totalPrice')}
      </Title>
      <Title level={1} className='text-light mt-2'>
        {
          totalPrice.toLocaleString(
            undefined, {
            minimumFractionDigits: 2,
          })
        }
        <Text className='text-light'> {TranslationKey('assetDetail.excludeVat')}</Text>
      </Title>
    </>
  );

  const DownloadButton = () => (
    <Row className='mt-3'>
      <Col span={24}>
        <Button
          type='primary'
          shape='round'
          className='btn-primary'
          size='large'
          onClick={onDownload}
          loading={downloadLoadings}
          block
        >
          Download
        </Button>
      </Col>
    </Row>
  );

  const InThisCollection = () => {
    if (collections.length === 0) {
      return <></>;
    }

    return (
      <div className='mt-5'>
        <h1 className='text-light collection'>
          {TranslationKey('assetDetail.inThisCollection')}
        </h1>
        <GallerysCollection
          isUseContainerImage={true}
          collectionAssetModel={collections[0]} />
      </div>
    );
  }

  const AssetMoreLikeThis = () => (
    <div className='mt-5'>
      {
        relateKeywords.length > 0 &&
        <GallerysMoreLikeThis
          assetId={asset?.id || ''}
          keywords={relateKeywords} />
      }
    </div>
  );

  return (
    <>
      <HelmetComponent
        title={`${PageDocument.Title} - ${asset ? asset.code + ' ' + asset.name : ''} `}
        description={asset?.description}
        imageUrl={thumbnailImageUrl}
      />
      <div className='price banner-margin-t-70'>
        {contextHolder}
        <div className='container'>
          {
            asset &&
            <Row gutter={16} className='mt-2'>
              <Col className='gutter-row' span={24} xl={14}>
                {AssetViewBox()}
                {ArtistProfile()}
                {AssetUsageTag()}
                <Row align='middle' className='mt-3'>
                  <Col>
                    {asset.description}
                  </Col>
                </Row>
                <div className='mt-3'>
                  {AssetUsageDescription()}
                </div>
                {Keywords()}
              </Col>
              <Col className='gutter-row product' span={24} xl={10}>
                {AssetTitleDescription()}
                {LicenseSelector()}
                {ActionButtons()}
                {
                  canDownloadAssetLicense &&
                  <DownloadButton />
                }
              </Col>
            </Row>
          }
          {InThisCollection()}
          {AssetMoreLikeThis()}
        </div>
        <AssetZoomModal />
        <MyFavoriteModal
          isFavoriteModalOpen={isOpenFavorite}
          assetId={orderAsset.id!}
          onCloseFavoriteModal={handleCloseFav}
        />
        <ShareModal
          isModalOpen={isOpenShare}
          sharedUrl={window.location.href}
          onClose={handleCloseShare}
        />
        <ReportAssetModal
          isModalOpen={isOpenReport}
          onClose={handleCloseReport}
          assetId={asset?.id!}
        />
      </div>
    </>
  );
}